import { render, staticRenderFns } from "./advanced-tabbed-nav-transition.vue?vue&type=template&id=542ee61a&"
import script from "./advanced-tabbed-nav-transition.vue?vue&type=script&lang=js&"
export * from "./advanced-tabbed-nav-transition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports